import { PortCallProps } from '@api/models/port-call';
import { PortCallActionProps } from '@api/models/port-call-action';
import { PortActionTypes } from './constants';

export const getPortCallActionStatus = (pca: PortCallActionProps & {
	PortCall: PortCallProps
}) => {
	switch (pca.event) {
		case PortActionTypes.DEPARTURE:
		case PortActionTypes.COMMENCEMENT:
		case PortActionTypes.COMPLETION:
		case PortActionTypes.REDELIVERY:
		case PortActionTypes.REDELIVERING_TC_IN:
			return pca.PortCall?.departureDate == null;

		case PortActionTypes.ARRIVAL:
		case PortActionTypes.DELIVERY:
		default:
			return pca.PortCall?.arrivalDate == null;
	} 
};
